<div class="hours-of-operation">
  <mat-card appearance="outlined" class="hours-of-operation__card" [ngClass]="{ outline: appearance === 'outline' }">
    <mat-card-header class="hours-of-operation__header">
      <mat-card-title>
        <span class="hours-of-operation__header__title">
          {{ 'FRONTEND.FORMS.HOURS_OF_OPERATION.HOURS_OF_OPERATION' | translate }}
          <span *ngIf="markedAsRequired">*</span>
        </span>
      </mat-card-title>
      <button
        mat-icon-button
        mat-inline
        type="button"
        [color]="'primary'"
        (click)="openEditDialog()"
        [disabled]="control.disabled"
      >
        <mat-icon>mode_edit</mat-icon>
      </button>
    </mat-card-header>
    <mat-card-content class="hours-of-operation__hours">
      <forms-day-of-week-display
        *ngFor="let day of [0, 1, 2, 3, 4, 5, 6]"
        [control]="control"
        [dayOfWeek]="dayOfWeek(day)"
      ></forms-day-of-week-display>
    </mat-card-content>
  </mat-card>
</div>
